<aside
  class="sidebar-wrapper bg-primary d-flex flex-column h-100"
  [class.opened]="isSidebarOpened$ | async"
  (isEnglish)="isEnglish = $event"
>
  <div class="sidebar-content overflow-auto w-100 h-100">
    <mat-list class="d-flex flex-column p-0" role="list">
      @if (userInfo()) {
        <mat-list-item
          role="listitem"
          class="user-photo"
          [style.width]="(isSidebarOpened$ | async) ? '240px' : '0'"
          [style.height]="(isSidebarOpened$ | async) ? '248px' : '0'"
          [style.opacity]="(isSidebarOpened$ | async) ? '1' : '0'"
        >
          <div class="d-flex flex-column justify-content-center align-items-center mb-3">
            @let userPhoto = userInfo()?.userAttachments;
            @if (userPhoto && userPhoto.length) {
              <img
                class="circle-image mb-4"
                [src]="userPhoto[0].url"
                (error)="userPhoto[0].url = 'assets/images/avatar.png'"
                alt="user-photo"
              />
            } @else {
              <img class="circle-image mb-4" src="assets/images/avatar.png" alt="user-photo" />
            }

            <div>
              <p class="font-20 bold text-white text-center">{{ isEnglish ? userInfo()!.nameEn : userInfo()!.nameAr }}</p>
              @if (isMembershipUser()) {
                <p class="font-14 bold text-white text-center">{{ "FRIENDS_OF_OMAN_MUSEUM.MUSEUM_FRIENDS" | translate }}</p>
              }
              <hr class="underline" />
            </div>
          </div>
        </mat-list-item>
      }

      @for (sidebarItem of sidebarItems; track $index) {
        @if (sidebarItem.permissions && sidebarItem.permissions.includes(userRole()!)) {
          @if (!sidebarItem.basedOnCondition || sidebarItem.basedOnCondition()) {
            <mat-list-item role="listitem">
              <app-sidebar-list-item [sidebarItem]="sidebarItem" />
            </mat-list-item>
          }
        }
      }

      @if (!isGuest()) {
        <mat-list-item role="listitem">
          <app-sidebar-list-item [sidebarItem]="logoutItem" (click)="logOut()" />
        </mat-list-item>
      }
    </mat-list>
  </div>
</aside>
